<template>
  <transition name="modal">
    <div
      class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-5"
      v-if="showModalCreate"
    >
      <div class="flex items-center justify-center h-full w-full">
        <div
          class="w-full max-w-xl bg-white dark:bg-slate-800 rounded-2xl shadow-2xl overflow-hidden h-auto min-h-[400px] max-h-[90vh] flex flex-col p-8 md:w-[550px] md:mx-auto max-md:w-[90%] max-md:my-5 max-md:p-4"
        >
          <div class="flex flex-col items-center w-full">
            <div
              class="w-full max-w-[450px] text-left mx-auto py-5 max-md:w-full max-md:px-0"
            >
              <div
                class="w-12 h-12 mb-4 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center"
              >
                <svg
                  class="w-7 h-7 text-blue-600 dark:text-blue-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                  />
                </svg>
              </div>
              <h2
                class="text-2xl font-semibold text-gray-900 dark:text-white mb-6"
              >
                Questionário Suitability
              </h2>
              <form
                class="space-y-4 w-full"
                @submit.stop.prevent="createRepresentante"
              >
                <div
                  class="mb-4 w-full min-h-[60px] max-h-[150px] max-md:w-full max-md:mb-2"
                >
                  <div class="w-full">
                    <label
                      class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                    >
                      {{ questaoAtual?.Pergunta || "Carregando pergunta..." }}
                    </label>
                  </div>
                </div>
                <div
                  class="mb-4 text-left w-full h-auto max-h-[350px] overflow-y-auto overflow-x-hidden max-md:ml-0 max-md:max-h-[250px] max-md:w-full scrollbar-thin scrollbar-thumb-gray-300"
                  v-if="
                    questaoAtual?.Respostas &&
                    questaoAtual.Respostas[0] != null &&
                    questaoAtual.Respostas[0].Opcoes?.length == 0
                  "
                >
                  <div
                    class="flex flex-col items-start w-full mb-2 pl-1"
                    v-for="(resposta, index) in questaoAtual.Respostas"
                    :key="index"
                  >
                    <div class="w-full">
                      <div class="flex items-center gap-3 w-full">
                        <RadioButton
                          v-if="questaoAtual.TipoResposta != 'Múltipla escolha'"
                          :inputId="`${resposta.QuestionarioRespostaId}`"
                          :value="resposta.QuestionarioRespostaId"
                          name="questionario"
                          v-model="selectedRadioOption"
                          @change="
                            salvarAlteracoesLocalmente(
                              resposta.QuestionarioRespostaId,
                              questaoAtual.QuestionarioId,
                            )
                          "
                        />
                        <Checkbox
                          v-if="
                            questaoAtual.TipoResposta == 'Múltipla escolha' &&
                            resposta.TipoResposta != 'Múltipla Escolha'
                          "
                          :inputId="`${resposta.QuestionarioRespostaId}`"
                          :value="resposta.QuestionarioRespostaId"
                          name="questionario"
                          v-model="selectedCheckboxOptions"
                          :binary="false"
                          @change="
                            salvarAlteracoesLocalmente(
                              resposta.QuestionarioRespostaId,
                              questaoAtual.QuestionarioId,
                            )
                          "
                        />
                        <Checkbox
                          v-if="
                            questaoAtual.TipoResposta == 'Múltipla escolha' &&
                            resposta.TipoResposta == 'Múltipla Escolha'
                          "
                          :inputId="`${resposta.QuestionarioRespostaId}`"
                          :value="resposta.QuestionarioRespostaId"
                          name="questionario"
                          v-model="selectedCheckboxOptions"
                          :binary="false"
                          @change="
                            salvarAlteracoesLocalmente(
                              resposta.QuestionarioRespostaId,
                              questaoAtual.QuestionarioId,
                              0,
                              true,
                            )
                          "
                        />
                        <label
                          class="text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer"
                          :for="`${resposta.QuestionarioRespostaId}`"
                        >
                          {{ resposta.Descricao }}
                        </label>
                      </div>
                    </div>
                    <div
                      v-if="
                        resposta.TipoResposta == 'Múltipla Escolha' &&
                        this.listaRespostasAtivas.findIndex(
                          (r) =>
                            r.QuestionarioRespostaId ===
                              resposta.QuestionarioRespostaId &&
                            r.QuestionarioId === questaoAtual.QuestionarioId,
                        ) > -1
                      "
                      class="ml-5 mt-2 border border-gray-300 dark:border-slate-600 rounded-lg p-2 w-[90%]"
                    >
                      <div
                        class="flex flex-col items-start w-full mb-2 pl-1"
                        v-for="(subResposta, index) in resposta.Opcoes"
                        :key="index"
                      >
                        <div class="w-full">
                          <div class="flex items-center gap-3 w-full">
                            <Checkbox
                              :inputId="`${subResposta.QuestionarioRespostaOpcaoId}`"
                              :value="`${subResposta.QuestionarioRespostaOpcaoId}`"
                              name="questionario"
                              :binary="false"
                              @click="
                                salvarAlteracoesLocalmente(
                                  resposta.QuestionarioRespostaId,
                                  questaoAtual.QuestionarioId,
                                  subResposta.QuestionarioRespostaOpcaoId,
                                )
                              "
                            />
                            <label
                              class="text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer"
                              :for="`${subResposta.QuestionarioRespostaOpcaoId}`"
                            >
                              {{ subResposta.Resposta }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="mb-4 text-left w-full h-auto max-h-[350px] overflow-y-auto overflow-x-hidden max-md:ml-0 max-md:max-h-[250px] max-md:w-full scrollbar-thin scrollbar-thumb-gray-300"
                  v-if="
                    questaoAtual?.Respostas &&
                    questaoAtual.Respostas[0] != null &&
                    questaoAtual.Respostas[0].Opcoes?.length > 0
                  "
                >
                  <table class="w-full border-collapse mb-5">
                    <thead>
                      <th
                        class="border border-gray-300 dark:border-slate-600 p-2 text-left font-inter font-medium text-sm text-gray-700 dark:text-gray-300"
                        style="width: 20%"
                      >
                        Item
                      </th>
                      <th
                        class="border border-gray-300 dark:border-slate-600 p-2 text-left font-inter font-medium text-sm text-gray-700 dark:text-gray-300"
                        style="width: 15%"
                      >
                        Tipo
                      </th>
                      <th
                        class="border border-gray-300 dark:border-slate-600 p-2 text-left font-inter font-medium text-sm text-gray-700 dark:text-gray-300"
                        style="width: 15%"
                      >
                        Classificação
                      </th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(resposta, index) in questaoAtual.Respostas"
                        :key="index"
                      >
                        <td
                          class="border border-gray-300 dark:border-slate-600 p-2 text-left font-inter text-sm text-gray-700 dark:text-gray-300"
                        >
                          {{ numeroQuestao + 1 }}.{{ index }}
                        </td>
                        <td
                          class="border border-gray-300 dark:border-slate-600 p-2 text-left font-inter text-sm text-gray-700 dark:text-gray-300"
                        >
                          {{ resposta.Descricao }}
                        </td>
                        <td
                          class="border border-gray-300 dark:border-slate-600 p-2"
                        >
                          <Dropdown
                            v-model="
                              selectedDropdowns[resposta.QuestionarioRespostaId]
                            "
                            :options="resposta.Opcoes"
                            optionLabel="Resposta"
                            optionValue="QuestionarioRespostaOpcaoId"
                            placeholder="Selecione"
                            class="w-full"
                            @change="
                              salvarAlteracoesLocalmente(
                                resposta.QuestionarioRespostaId,
                                questaoAtual.QuestionarioId,
                                $event.value,
                              )
                            "
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="flex flex-row justify-center gap-4 mt-5 mx-auto max-md:gap-2"
                >
                  <Button
                    label="Cancelar"
                    severity="secondary"
                    outlined
                    type="button"
                    @click="confirmarFechamento"
                    class="flex-1 max-w-[210px] h-10 max-md:max-w-[135px] max-md:min-w-[120px]"
                  />
                  <Button
                    v-if="
                      questionario && numeroQuestao + 1 < questionario.length
                    "
                    label="Próximo"
                    type="button"
                    @click="proximaQuestao()"
                    class="flex-1 max-w-[210px] h-10 max-md:max-w-[135px] max-md:min-w-[120px]"
                  />
                  <Button
                    v-if="
                      questionario && numeroQuestao + 1 == questionario.length
                    "
                    label="Concluir"
                    type="button"
                    @click="concluirQuestionario()"
                    class="flex-1 max-w-[210px] h-10 max-md:max-w-[135px] max-md:min-w-[120px]"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api/axios";
import RadioButton from "primevue/radiobutton";
import Checkbox from "primevue/checkbox";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import { TIPO_CLIENTE } from "@/constants/TipoClienteEnum";

export default {
  name: "ModalQuestionario",
  components: {
    RadioButton,
    Checkbox,
    Dropdown,
    Button,
  },
  computed: {
    isScrollable() {
      return false;
    },
    ...mapGetters({
      showModalCreate: "GET_MODAL_QUESTIONARIO",
      listaQuestoes: "GET_MODAL_LISTAR_QUESTIONARIO",
      retornoQuestionario: "GET_SALVAR_QUESTIONARIO",
      user: "auth/user",
    }),
  },
  data() {
    return {
      rowResponseHeight: 0,
      questionario: [],
      questaoAtual: null,
      numeroQuestao: 0,
      respostaQuestionario: {
        Respostas: [],
      },
      listaRespostasAtivas: [],
      selectedRadioOption: null,
      selectedCheckboxOptions: [],
      selectedDropdowns: {},
    };
  },
  mounted() {
    this.$store.commit("SET_PJ_SALVAR_INFO", false);
    this.listaRespostasAtivas = [];

    this.$store.dispatch("FETCH_QUESTIONARIO_BUSCAR_QUESTOES");

    if (this.listaQuestoes != null) {
      this.processarQuestoes();
    }
  },
  watch: {
    listaQuestoes() {
      this.processarQuestoes();
    },
    showModalCreate() {
      if (this.showModalCreate && this.questionario.length === 0) {
        this.questaoAtual = this.questionario[0];
        this.numeroQuestao = 0;
        this.respostaQuestionario.Respostas = [];
        this.listaRespostasAtivas = [];
      }
      // RESETAR MODELOS DE INPUT AO ABRIR MODAL
      if (this.showModalCreate) {
        this.resetarQuestionario();
        this.selectedRadioOption = null;
        this.selectedCheckboxOptions = [];
        this.respostaQuestionario.Respostas = [];
      }
      this.listaRespostasAtivas = [];
      if (this.listaQuestoes != null) {
        this.processarQuestoes();
      } else {
        this.$store.dispatch("FETCH_QUESTIONARIO_BUSCAR_QUESTOES");
      }
    },
    retornoQuestionario() {
      if (this.respostaQuestionario == null) {
        this.closeModal();
      }
    },
  },
  methods: {
    confirmarFechamento() {
      this.$alert({
        title: "Deseja realmente sair?",
        text: "Ao fechar, todas as respostas serão perdidas e o questionário recomeçará do início.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, sair",
        cancelButtonText: "Não, continuar respondendo",
      }).then((result) => {
        if (result.isConfirmed) {
          this.resetarQuestionario();
          this.closeModal();
        }
      });
    },
    resetarQuestionario() {
      this.numeroQuestao = 0;
      this.questaoAtual = this.questionario[0];
      this.respostaQuestionario.Respostas = [];
      this.listaRespostasAtivas = [];
      // Se salvar progresso em Vuex, limpe também:
      // this.$store.commit('SET_PROGRESSO_QUESTIONARIO', []);
    },
    processarQuestoes() {
      if (
        this.listaQuestoes &&
        this.listaQuestoes.length > 0 &&
        this.questaoAtual == null
      ) {
        // Filtra listaQuestoes para itens que correspondam ao TipoCliente do usuário
        const questoesFiltradas = this.listaQuestoes.filter(
          (questao) => questao.TipoCliente === this.user.TipoCliente,
        );
        // Atualiza questionario e questaoAtual com as questões filtradas
        if (questoesFiltradas.length > 0) {
          this.questionario = questoesFiltradas;
          this.questaoAtual = questoesFiltradas[0];
        } else {
          // Se nenhum item corresponder, você pode definir questionario e questaoAtual para valores padrão ou vazios
          this.questionario = [];
          this.questaoAtual = null; // ou {}, dependendo de como você quer lidar com "sem questões"
        }
      }
    },
    salvarAlteracoesLocalmente(
      QuestionarioRespostaId,
      QuestionarioId,
      OpcaoId = 0,
      habilitarSubResposta = false,
    ) {
      // Garantir que os IDs são números (para prevenir problemas de comparação de tipos)
      QuestionarioId = Number(QuestionarioId);
      QuestionarioRespostaId = Number(QuestionarioRespostaId);
      OpcaoId = Number(OpcaoId || 0);

      // Criar objeto de resposta com tipos corretos
      const novaResposta = {
        QuestionarioId: QuestionarioId,
        QuestionarioRespostaId: QuestionarioRespostaId,
        QuestionarioRespostaOpcaoId: OpcaoId,
      };

      // RADIO BUTTONS (resposta única)
      if (this.questaoAtual.TipoResposta !== "Múltipla escolha") {
        // 1. Criar um array temporário das respostas que queremos manter
        const respostasParaManter = this.respostaQuestionario.Respostas.filter(
          (resposta) => Number(resposta.QuestionarioId) !== QuestionarioId,
        );

        // 2. Adicionar explicitamente a nova resposta ao array temporário
        respostasParaManter.push(novaResposta);

        // 3. Substituir completamente o array original
        this.respostaQuestionario.Respostas = respostasParaManter;

        return; // IMPORTANTE: Sair da função aqui para radio buttons!
      }

      // MULTIPLA ESCOLHA COM DROPDOWN (SELECT)
      if (this.questaoAtual.Respostas[0]?.Opcoes?.length > 0) {
        // Remove qualquer resposta para o mesmo QuestionarioId e QuestionarioRespostaId
        this.respostaQuestionario.Respostas =
          this.respostaQuestionario.Respostas.filter(
            (resposta) =>
              !(
                Number(resposta.QuestionarioId) === QuestionarioId &&
                Number(resposta.QuestionarioRespostaId) ===
                  QuestionarioRespostaId
              ),
          );
        // Adiciona a nova resposta
        this.respostaQuestionario.Respostas.push(novaResposta);
        return;
      }

      // CHECKBOXES (múltipla escolha)

      // Verificar se a resposta já existe (caso de desmarcação)
      let index = -1;
      if (habilitarSubResposta) {
        index = this.listaRespostasAtivas.findIndex(
          (resposta) =>
            Number(resposta.QuestionarioRespostaId) ===
              QuestionarioRespostaId &&
            Number(resposta.QuestionarioId) === QuestionarioId &&
            Number(resposta.QuestionarioRespostaOpcaoId) === OpcaoId,
        );
      } else {
        index = this.respostaQuestionario.Respostas.findIndex(
          (resposta) =>
            Number(resposta.QuestionarioRespostaId) ===
              QuestionarioRespostaId &&
            Number(resposta.QuestionarioId) === QuestionarioId &&
            Number(resposta.QuestionarioRespostaOpcaoId) === OpcaoId,
        );
      }

      // Se a resposta já existe, remover (desmarcação de checkbox)
      if (index !== -1) {
        if (habilitarSubResposta) {
          this.listaRespostasAtivas.splice(index, 1);

          // Remover todas as sub-respostas relacionadas
          let indexSubResposta = 0;
          while (indexSubResposta >= 0) {
            indexSubResposta = this.respostaQuestionario.Respostas.findIndex(
              (resposta) =>
                Number(resposta.QuestionarioRespostaId) ===
                  QuestionarioRespostaId &&
                Number(resposta.QuestionarioId) === QuestionarioId,
            );

            if (indexSubResposta !== -1) {
              this.respostaQuestionario.Respostas.splice(indexSubResposta, 1);
            } else {
              break; // Evitar loop infinito
            }
          }
        } else {
          this.respostaQuestionario.Respostas.splice(index, 1);
        }
      } else {
        // Adicionar nova resposta (checkbox marcado)
        if (habilitarSubResposta) {
          this.listaRespostasAtivas.push({ ...novaResposta });
        } else {
          this.respostaQuestionario.Respostas.push({ ...novaResposta });
        }
      }
    },
    concluirQuestionario() {
      if (!this.capturarResposta()) {
        this.$alert({
          icon: "error",
          title: "Não preenchido",
          text: `Necessário responder para avançar o questionário`,
        });
        return;
      }
      this.salvarFormulario();
    },
    capturarResposta() {
      const respostasParaQuestaoAtual =
        this.respostaQuestionario.Respostas.filter(
          (resposta) =>
            resposta.QuestionarioId === this.questaoAtual.QuestionarioId,
        );

      // Se a questão usa opções simples (sem sub-opções)
      if (this.questaoAtual.Respostas[0]?.Opcoes?.length === 0) {
        return respostasParaQuestaoAtual.length > 0;
      }

      // Se a questão usa tabela/seleção, todas as respostas devem estar preenchidas
      else if (this.questaoAtual.Respostas[0]?.Opcoes?.length > 0) {
        return (
          respostasParaQuestaoAtual.length ===
          this.questaoAtual.Respostas.length
        );
      }

      return false;
    },
    limparRespostas() {
      // Este método é chamado antes de trocar para a próxima questão
      // Sua função é evitar que respostas anteriores apareçam na próxima questão

      // Resetar os modelos de dados vinculados aos inputs
      this.selectedRadioOption = null;
      this.selectedCheckboxOptions = [];

      // Vamos verificar se a próxima questão já tem respostas salvas
      if (this.numeroQuestao + 1 < this.questionario.length) {
        const proximaQuestao = this.questionario[this.numeroQuestao + 1];
        if (proximaQuestao) {
          // Encontrar e remover a resposta da próxima questão no objeto respostaQuestionario
          const indexProximaResposta =
            this.respostaQuestionario.Respostas.findIndex(
              (resp) => resp.QuestionarioId === proximaQuestao.QuestionarioId,
            );

          // Se encontrou resposta pré-existente para a próxima questão, remove ela
          if (indexProximaResposta >= 0) {
            this.respostaQuestionario.Respostas.splice(indexProximaResposta, 1);
          }
        }
      }
    },
    proximaQuestao() {
      if (!this.capturarResposta()) {
        this.$alert({
          icon: "error",
          title: "Não preenchido",
          text: `Necessário responder para avançar o questionário`,
        });
        return;
      }
      this.limparRespostas();
      this.numeroQuestao++;

      this.questaoAtual = this.questionario[this.numeroQuestao];
    },
    closeModal() {
      this.$store.commit("SET_MODAL_QUESTIONARIO", false);
    },
    logoff() {
      this.$store.dispatch("auth/logout");
    },
    async calcularPrevia() {
      await api
        .post("/suitability/preview", this.respostaQuestionario)
        .then((retorno) => {
          if (retorno.status == 200) {
            this.$store.commit("SET_SUITABILITY_PREVIEW", retorno.data);
          }
        })
        .catch((error) => {
          this.$alert({
            icon: "error",
            title: "Dados informados inválidos.",
            text: `${error.response.data.data[0]}`,
          });
        });
    },
    async salvarFormulario() {
      this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", true);
      if (this.user.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA) {
        this.$store.commit("SET_PJ_SALVAR_INFO", true);
      } else if (this.user.TipoCliente == TIPO_CLIENTE.PESSOA_FISICA) {
        this.$store.commit("SET_PF_SALVAR_INFO", true);
      }

      this.$store.commit("SET_SALVAR_QUESTIONARIO", this.respostaQuestionario);
      this.$store.commit("SET_ETAPA_CONCLUIDA", 9);

      await this.calcularPrevia();

      this.closeModal();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");

.font-inter {
  font-family: "Inter", sans-serif;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.scrollbar-thin::-webkit-scrollbar {
  width: 6px;
}

.scrollbar-thin::-webkit-scrollbar-thumb {
  @apply bg-gray-300 rounded;
}

.scrollbar-thin {
  scrollbar-width: thin;
}
</style>
